import { WifiOff, Wifi, Cloud, CloudOff, RefreshCw } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import { useOfflineSync } from '@/hooks/useOfflineSync';
import { cn } from '@/lib/utils';

export function OfflineIndicator() {
  const { isOnline } = useOfflineStatus();
  const { pendingCount, isSyncing, syncNow } = useOfflineSync();

  return (
    <div className="flex items-center gap-2">
      {/* Pending sync badge */}
      {pendingCount > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge 
              variant="secondary" 
              className="gap-1.5 bg-amber-600/10 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400 border-amber-600/20"
            >
              <CloudOff className="h-3 w-3" />
              {pendingCount}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>{pendingCount} entrada(s) aguardando sincronização</p>
          </TooltipContent>
        </Tooltip>
      )}

      {/* Sync button when online with pending */}
      {isOnline && pendingCount > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={syncNow}
              disabled={isSyncing}
            >
              <RefreshCw className={cn("h-4 w-4", isSyncing && "animate-spin")} />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Sincronizar agora</p>
          </TooltipContent>
        </Tooltip>
      )}

      {/* Online/Offline status */}
      <Tooltip>
        <TooltipTrigger asChild>
          <div 
            className={cn(
              "flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium transition-colors",
              isOnline 
                ? "bg-emerald-600/10 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400" 
                : "bg-destructive/10 text-destructive"
            )}
          >
            {isOnline ? (
              <>
                <Wifi className="h-3 w-3" />
                <span className="hidden sm:inline">Online</span>
              </>
            ) : (
              <>
                <WifiOff className="h-3 w-3" />
                <span className="hidden sm:inline">Offline</span>
              </>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{isOnline ? 'Conectado à internet' : 'Sem conexão - modo offline ativo'}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
